import React, { forwardRef } from 'react';
import Type from 'prop-types';
import { useEffectOnce } from 'react-use';
import {
  AutoSizer,
  List,
  CellMeasurer,
  CellMeasurerCache,
} from 'react-virtualized';
import { Divider } from "@mui/material";
import PledgeItem from '../PledgeItem';

const cache = new CellMeasurerCache({
  fixedWidth: true,
  defaultHeight: 200,
});

const PledgeList = forwardRef((props, ref) => {
  const { pledges, listHeight } = props;
  const rowCount = pledges.length;

  useEffectOnce(() => {
    cache.clearAll();
  });

  const rowRenderer = (rowData) => {
    const { index, parent, key, style } = rowData;
    const pledge = pledges[index];

    return (
      <CellMeasurer
        cache={cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        <div style={style}>
          <PledgeItem pledge={pledge} />
          <Divider />
        </div>
      </CellMeasurer>
    );
  };

  return (
    <AutoSizer disableHeight>
      {({ width }) => (
        <List
          ref={ref}
          height={listHeight}
          overscanRowCount={2}
          rowCount={rowCount}
          deferredMeasurementCache={cache}
          rowHeight={cache.rowHeight}
          rowRenderer={rowRenderer}
          width={width}
        />
      )}
    </AutoSizer>
  );
});

PledgeList.propTypes = {
  listHeight: Type.number.isRequired,
  pledges: Type.arrayOf(Type.shape(PledgeItem.propTypes.operation)).isRequired,
};

export default PledgeList;
